<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="mb-0 color-black check-text-center">
          {{ prescription_care.care_name }}
        </h6>
        <h6 class="worksansr break-word check-text-center">
          {{ prescription_care.care_active_ingredient }}
        </h6>
      </div>
      <div class="col-md-12">
        <h6 class="worksansr">
          DATA DE INICIO DO MEDICAMENTO COM O(S) HORÁRIO(S):
        </h6>
        <input v-model="init" type="date" class="form-control" />
      </div>
    </div>
    <div
      class="row"
      v-for="prescription_care_time in prescription_care.prescription_care_time"
      :key="prescription_care_time.id"
    >
      <div
        v-show="prescription_care.frequency != 'EVENTUAL'"
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
      >
        <LabelRequiredField label="HORÁRIO" />
        <input
          :data-edit_id="prescription_care_time.id"
          :data-edit_prescription_care_id="
            prescription_care_time.prescription_care_id
          "
          :ref="`edit_schedule_${prescription_care.id}`"
          type="time"
          class="form-control"
          @input="handleDistributeSchedules"
        />
      </div>
      <div
        :class="[
          prescription_care.frequency != 'EVENTUAL'
            ? 'col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'
            : 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12',
        ]"
      ></div>
    </div>
    <div class="row">
      <div class="col-md-12"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-6">
        <v-btn class="btn-cancel" @click="$bvModal.hide('edit_time')"
          ><i class="fas fa-times mr-2"></i>CANCELAR</v-btn
        >
      </div>
      <div class="col-md-6 text-right">
        <v-btn @click="save" :disabled="loading" class="btn-save"
          ><i class="fas fa-check mr-2"></i>SALVAR</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import LabelRequiredField from "../../Components/LabelRequiredField";

import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import { numbersOnly } from "../../../lib/format";

export default {
  name: "EditCareTime",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    prescription_care: { type: Object },
  },

  data() {
    return {
      errors: [],

      loading: false,

      init: "",
    };
  },

  methods: {
    handleDistributeSchedules(e) {
      let { value } = e.target;
      let { edit_id, edit_prescription_care_id } = e.target.dataset;

      let inputs = document.querySelectorAll(
        `input[data-edit_prescription_care_id="${edit_prescription_care_id}"]`
      );

      if (edit_id != inputs[0].dataset.edit_id) {
        return;
      }

      if (inputs.length == 1) {
        return;
      }

      if (inputs[1].value) {
        return;
      }

      let countTimes = 0;

      for (let input of inputs) {
        if (
          input.dataset.edit_prescription_care_id == edit_prescription_care_id
        ) {
          countTimes++;
        }
      }

      if (countTimes == 5 || countTimes == 7 || countTimes == 9) {
        return;
      }

      let every = 24 / countTimes;

      if (String(every).length == 1) {
        every = `0${every}:00`;
      } else if (String(every).length == 2) {
        every = `${every}:00`;
      }

      for (let i = 0; i < inputs.length; i++) {
        let time =
          parseInt(numbersOnly(value)) +
          parseInt(numbersOnly(i == 0 ? 0 : every)) * i;

        if (String(time).length == 1) {
          time = `0${time}00`;
        } else if (String(time).length == 2) {
          time = `${time}00`;
        } else if (String(time).length == 3) {
          time = `0${time}`;
        }

        if (parseInt(time) == 2400) {
          time = "00:00";
        } else if (parseInt(time) > 2400) {
          time = null;
        }

        if (time) {
          let half = Math.floor(String(time).length / 2);
          inputs[i].value =
            String(time).substr(0, half) + ":" + String(time).substr(half);
        }
      }
    },

    async save() {
      try {
        this.loading = true;

        let { prescription_care, init } = this;

        let prescription_care_time = [];

        let refs = this.$refs[`edit_schedule_${prescription_care.id}`];

        for (let item of refs) {
          let obj = {
            id: item.dataset.edit_id,
            time: item.value,
            prescription_care_id: item.dataset.edit_prescription_care_id,
          };

          prescription_care_time.push(obj);
        }

        let params = {
          init,
          prescription_care: {
            id: prescription_care.id,
            frequency: prescription_care.frequency,
          },
          prescription_care_time,
        };

        const response = await api.patch(
          "/rest-home/care-schedule/time",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("edit_time");
          this.$emit("paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
